import React, { createContext, useContext, useState } from "react";

// Create the Context
const ModalContext = createContext();

// Create a Provider Component
export const ModalProvider = ({ children }) => {
  const [isChangeModalOpen, setIsChangeModalOpen] = useState(false);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);

  return (
    <ModalContext.Provider
      value={{
        isChangeModalOpen,
        setIsChangeModalOpen,
        isCancelModalOpen,
        setIsCancelModalOpen,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

// Custom Hook to use the Modal Context
export const useModal = () => {
  return useContext(ModalContext);
};
